export default {
 
  allAgents: state => {
    return state.agents
  },
  allBetRecords : state => {
    return state.betrecords
  },
  allBetBaccarats : state => {
    return state.betrecordbacarat
  },
  allBetLonghu :  state => {
    return state.betrecordlonghu
  },
  allBetSicbo : state => {
    return state.betrecordsicbo
  },
  allBetRoulette :  state => {
    return state.betrecordroulette
  },
  allExchangeReport :  state => {
    return state.curexchangereport
  },
  allAgentCreditReport :  state => {
    return state.agentcreditreport
  },
  allClientCreditReport :  state => {
    return state.clientcreditreport
  },
  allOperationLogReport :  state => {
    return state.operatorlogreports
  },
  allAgentAmountReports : state => {
    return state.agentamountrecord
  },
  allProfitLossReports : state => {
    return state.profitlossreport
  },
  allRebateReports : state => {
    return state.claimrebatereports
  },
  allTabs: state => {
    return state.tabs
  },
  allMasterAgentChilds: state => {
    return state.masteragentchilds
  },
  allMasterAgentClients: state => {
    return state.masteragentclients
  },
  allAgentChilds: state => {
    return state.agentchilds
  },
  allAgentClients: state => {
    return state.agentclients
  },
  allAgentSubaccounts: state => {
    return state.agentsubaccounts
  },

  listBetLimit: state =>{
    return state.listbetlimit
  },
  // OLD
  authUser: state => {
    return state.user
  },

  notifications: state => {
    return state.notifications
  },

  authToken: state => {
    return state.token
  },

  allTasks: state => {
    return state.tasks
  },

  allVendors: state => {
    return state.vendors
  },

  allWithdrawals: state => {
    return state.withdrawals
  },

  singleWithdrawal: state => {
    return state.withdrawal
  },

  allDeposits: state => {
    return state.deposits
  },

  singleDeposit: state => {
    return state.deposit
  },

  activeTasks: state => {
    return state.tasks.filter(todo => !todo.done)
  },

  completedTasks: state => {
    return state.tasks.filter(todo => todo.done)
  },

  allUsers: state => {
    return state.users
  },

  singleUser: state => {
    return state.user
  },

  singlePlayer :state=> {
    return state.player
  }
}
